import PropTypes from 'prop-types';
import React from 'react';

import * as benchlingUtil from 'BenchlingUtil';
import {Label} from 'bulk-workflows/BulkWorkflowComponents';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import HorizontalThrobber from 'ui-library/HorizontalThrobber';
import {Cell, Column, Table} from 'ui-library/simple-table/SimpleTable';
import TextValue from 'ui-library/TextValue';

import * as BulkAntibodyActions from '../BulkAntibodyActions';
import * as BulkAntibodyConstants from '../BulkAntibodyConstants';
import * as BulkAntibodyUtil from '../BulkAntibodyUtil';

function _handleCreate() {
  BulkAntibodyActions.create();
}

function BasicFolderItemPreview({name, tags}) {
  return (
    <div>
      <p>{name}</p>
      <div className="u-overflow-x-hidden">
        <Row>
          {Object.entries(tags).map(([tagName, tag]) => (
            <Col key={tagName} sm={6}>
              <Label allCaps={true}>{tagName}</Label>
              <span>
                <TextValue value={tag.value} />
              </span>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
}

BasicFolderItemPreview.propTypes = {
  name: PropTypes.string.isRequired,
  tags: PropTypes.object.isRequired,
};

function BulkAntibodySummary({bulkAntibody}) {
  if (bulkAntibody.inputFilesLoading) {
    return <HorizontalThrobber />;
  }
  const bfiSpecs = BulkAntibodyUtil.getBasicFolderItemSpecs(bulkAntibody);
  return (
    <div>
      <p>
        {bfiSpecs.length} {benchlingUtil.pluralize(bfiSpecs.length, 'antibody', 'antibodies')} will be
        created.
      </p>
      <Label>Preview</Label>
      <Table numRows={bfiSpecs.length}>
        <Column
          renderCell={(bfiIndex) => (
            <Cell>
              <BasicFolderItemPreview {...bfiSpecs[bfiIndex]} />
            </Cell>
          )}
        />
      </Table>
      <Button
        buttonStyle={ButtonStyle.SECONDARY}
        size={ButtonSize.MEDIUM}
        disabled={bulkAntibody.isCreating}
        text={bulkAntibody.isCreating ? 'Creating...' : 'Create'}
        onClick={_handleCreate}
      />
    </div>
  );
}

BulkAntibodySummary.propTypes = {
  bulkAntibody: BulkAntibodyConstants.BULK_ANTIBODY.isRequired,
};

export default BulkAntibodySummary;
